import React from 'react'
import { CurrencySelectorProps } from './CurrencySelector.types'
import styles from './CurrencySelector.module.scss'
import cl from 'classnames'
import { Text1 } from '../Text1'
import { Select } from '../Select'

const CurrencySelectorComponent = (props: CurrencySelectorProps) => {
  const {
    className,
    style
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <Text1
        style={{
          color: styles.secondaryContent,
          marginLeft: 'auto'
        }}
      >
        Currency
      </Text1>
      <Select
        noNoneOption
        value={'USD'}
        options={[{ label: 'USD', value: 'USD' }]}
        // onChange={setSelectedStoreId}
        style={{
          maxWidth: 100,
          marginLeft: 10
        }}
      />
    </div>
  )
}

const CurrencySelector = CurrencySelectorComponent
export { CurrencySelector }
